import GameDetail from '@/apps/GameDetail'
import Layout from '@/apps/layout/components'
import React from 'react'

const GameDetailPage = (): React.ReactElement => {
  return (
    <Layout>
      <GameDetail />
    </Layout>
  )
}

export default GameDetailPage
